import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.greyBackground};
  padding: 5px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  div {
    display: flex;
    align-items: center;

    h1 {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  aside {
    display: flex;
    align-items: center;

    svg {
      font-size: 20px;
    }

    button {
      background: transparent;
      border: none;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }

      & + button {
        margin-left: 10px;
      }
    }
  }
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;

  h1 {
    margin-top: 1rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.blue};
  }

  table {
    color: #545454;
    thead th {
      background: ${({ theme }) => theme.colors.white};
      position: sticky;
      top: 0;
    }

    td,
    th {
      padding: 5px 15px 5px 15px;
      cursor: default;
    }

    .user {
      width: 20%;
    }

    .note {
      width: 10%;
      text-align: center;
    }
  }
`;

export const Resume = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    margin: 2rem 0 3rem 0;
    text-align: center;
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.5rem;
  }

  > span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primary};
    margin: 1rem 10%;
  }

  div {
    align-self: center;
    height: 1px;
    width: 80%;
    border-bottom: 1px solid #000;
  }
`;
